import api from './api';
import type { Patient, Rental, PaginatedResponse } from '@/types';

export interface ListPatientsParams {
  status?: string;
  search?: string;
  clinicId?: string;
  doctorId?: string;
  page?: number;
  limit?: number;
}

export interface CreatePatientDto {
  firstName: string;
  lastName: string;
  email?: string;
  phone?: string;
  age?: number;
  dateOfBirth?: string;
  gender?: string;
  streetAddress?: string;
  city?: string;
  province?: string;
  postalCode?: string;
  country?: string;
  referredByDoctorId?: string;
  clinicId?: string;
  notes?: string;
}

export interface AssignPatientDto {
  patientIds: string[];
  clinicId: string;
  assignedBy?: string;
}

export const patientsApi = {
  list: async (params: ListPatientsParams = {}) => {
    const response = await api.get<PaginatedResponse<Patient>>('/patients', { params });
    return response.data;
  },

  getById: async (id: string) => {
    const response = await api.get<Patient>(`/patients/${id}`);
    return response.data;
  },

  create: async (dto: CreatePatientDto) => {
    const response = await api.post<Patient>('/patients', dto);
    return response.data;
  },

  update: async (id: string, dto: Partial<CreatePatientDto>) => {
    const response = await api.patch<Patient>(`/patients/${id}`, dto);
    return response.data;
  },

  search: async (q: string, clinicId?: string, limit?: number) => {
    const response = await api.get<Patient[]>('/patients/search', {
      params: { q, clinicId, limit },
    });
    return response.data;
  },

  getRentals: async (id: string, params: { page?: number; limit?: number } = {}) => {
    const response = await api.get<PaginatedResponse<Rental>>(`/patients/${id}/rentals`, { params });
    return response.data;
  },

  assignToClinic: async (dto: AssignPatientDto) => {
    const response = await api.post('/patients/assign', dto);
    return response.data;
  },

  removeFromClinic: async (patientId: string, clinicId: string) => {
    const response = await api.delete(`/patients/${patientId}/clinics/${clinicId}`);
    return response.data;
  },
};

export default patientsApi;
